import React from 'react';
import { Box, Card } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const CardSkeleton = ({ height = 300, rows = 5, fullHeight = false }) => (
  <Card style={{ width: '100%', border: '1px solid #E5E7EB', borderRadius: 10, backgroundColor: '#FFFFFF', overflow: 'hidden', boxShadow: '0 4px 18px rgba(15, 23, 42, 0.05)', height: fullHeight ? '100%' : height, minHeight: fullHeight ? undefined : height, display: 'flex', flexDirection: 'column' }} elevation={1}>
    <Box style={{ padding: '14px 18px', borderBottom: '1px solid #EEF0F4', display: 'flex', alignItems: 'center' }}>
      <Skeleton variant="rect" width={30} height={30} style={{ borderRadius: 8, marginRight: 8 }} />
      <Skeleton variant="text" width={140} height={22} />
    </Box>

    <Box px={2} style={{ flex: 1 }}>
      {Array.from({ length: rows }).map((_, index) => (
        <Box key={index} display="flex" alignItems="center" justifyContent="space-between" py={1.15}>
          <Skeleton variant="text" width="45%" height={18} />
          <Skeleton variant="text" width="20%" height={18} />
        </Box>
      ))}
    </Box>
  </Card>
);

export default CardSkeleton;
